export default {
	bizInspectStatisticsReport: {
		title: 'Informe Estadístico',
		dateRange: {
			startDate: 'Fecha de Inicio',
			endDate: 'Fecha de Fin',
			separator: 'a'
		},
		query: 'Consultar',
		export: 'Exportar',
		loading: 'Actualizando datos, por favor espere...',
		updateSuccess: 'Actualización de datos completada',
		charts: {
			deviceRun: 'Estado de Operación del Equipo',
			deviceWarn: 'Estado General de Alarmas',
			deviceHealth: 'Estado General de Monitoreo',
			warnType: 'Estadísticas de Tipos de Fallas',
			deviceType: 'Estadísticas de Fallas de Equipos de la Planta',
			warnTrend: 'Tendencia de Alarmas de Equipos',
			warnList: 'Alarmas de Puntos de Sensores',
			reportList: 'Casos de Fallas',
			mtbfStatistics: 'Estadísticas de MTBF de Equipos'
		},
		deviceRun: {
			total: 'Total',
			running: 'En Funcionamiento',
			stopped: 'Detenido',
			offline: 'Desconectado'
		},
		deviceWarn: {
			severe: 'Severo',
			medium: 'Medio',
			general: 'General',
			normal: 'Normal'
		},
		warnTrend: {
			generalAlarm: 'Alarma General',
			mediumAlarm: 'Alarma Media',
			severeAlarm: 'Alarma Severa'
		},
		warnList: {
			index: 'Índice',
			deviceName: 'Equipo de Alarma',
			pointName: 'Punto de Alarma',
			reason: 'Razón de Alarma',
			level: 'Nivel de Alarma',
			time: 'Tiempo de Alarma',
			general: 'General',
			medium: 'Medio',
			severe: 'Severo',
			normal: 'Normal'
		},
		reportList: {
			index: 'Índice',
			attachment: 'Archivo Adjunto',
			type: 'Tipo de Caso',
			author: 'Autor',
			time: 'Tiempo de Emisión',
			healthReport: 'Informe de Salud',
			diagnosisReport: 'Informe de Diagnóstico'
		},
		mtbfStatistics: {
			index: 'Índice',
			deviceName: 'Nombre del Equipo',
			faultCount: 'Recuento de Fallas',
			avgInterval: 'Intervalo Promedio (h)',
			lastFault: 'Última Falla'
		},
		deviceTypeChart: {
			title: 'Vista General de Equipos',
			total: 'Total',
			unit: 'unidades'
		},
		warnTypeChart: {
			title: 'Estadísticas de Tipos de Fallas',
			total: 'Total',
			unit: 'casos'
		}
	}
}
